'use client';

import React, { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const Modal = ({ children, useBody = false }: { children: ReactNode; useBody?: boolean }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  return mounted
    ? createPortal(
        children as React.JSX.Element,
        useBody ? document.body : (document.querySelector('#__modal') as Element),
      )
    : null;
};
